import React, { useEffect } from 'react'
import { useStore } from 'src/Packages/Plugins/TechDivision.Journal/Resources/Private/App/Store/useStore'

const Journal = ({ resultItem }) => {
    const translations = useStore((state) => state.translations)
    const addIconFadeAnimations = (btn, mouseover = true) => {
        if (mouseover) {
            btn.classList.remove('btn--icon-fade-out-animation')
            btn.classList.add('btn--icon-fade-in-animation')
        } else {
            btn.classList.add('btn--icon-fade-out-animation')
            btn.classList.remove('btn--icon-fade-in-animation')
        }
    }

    const itemLogo = () => {
        if (!resultItem.imageUri) return ''
        return (
            <a href={resultItem.targetUri} className="journal-list__item-logo">
                <img src={resultItem.imageUri} loading="lazy" alt="" />
            </a>
        )
    }

    const itemCompany = () => {
        if (!resultItem.company) return ''
        return (
            <p className="journal-list__item-company">
                <a href={resultItem.targetUri}>{resultItem.company}</a>
            </p>
        )
    }

    const itemLocation = () => {
        if (!resultItem.location) return ''
        return <div className="journal-list__item-description">{resultItem.location}</div>
    }

    const itemHeadline = () => {
        if (!resultItem.title) return ''
        return (
            <h4 className="journal-list__item-headline">
                <a href={resultItem.targetUri}>{resultItem.title}</a>
            </h4>
        )
    }

    const itemDescription = () => {
        if (!resultItem.description) return ''
        return (
            <div
                className="journal-list__item-description"
                dangerouslySetInnerHTML={{ __html: resultItem.description }}
            />
        )
    }

    const itemAddress = () => {
        if (!resultItem.address) return ''
        return (
            <div className="journal-list__item-description" dangerouslySetInnerHTML={{ __html: resultItem.address }} />
        )
    }

    const actionItem = () => {
        if (!resultItem.targetUri) return ''

        return (
            <div
                className="journal-list__item-actions btn-wrapper"
                onMouseOver={(e) => addIconFadeAnimations(e.currentTarget, true)}
                onMouseOut={(e) => addIconFadeAnimations(e.currentTarget, false)}
            >
                <div className="journal-list__item-specification">{resultItem.date}</div>
                <a href={resultItem.targetUri}>{resultItem.btnText ? resultItem.btnText : translations.button}</a>
                <div className={'button--arrow'}></div>
            </div>
        )
    }

    return (
        <div className="journal-list__item">
            <div className="journal-list__item--content">
                {itemLogo()}
                {itemLocation()}
                {itemCompany()}
                {itemHeadline()}
                {itemDescription()}
                {itemAddress()}
            </div>
            {actionItem()}
        </div>
    )
}

export default Journal
